import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import TrashIcon from "../components/TrashIcon";

const DocumentItem = ({ document, readOnly, handleTrashClick, assetId }) => {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
      <Paper
        elevation={0.5}
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "start",
          p: 1,
          borderRadius: 1,
          border: "1px solid #ECEBEB",
          gap: 1,
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Stack
          width={"60%"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Box
            border="1px solid #ccc"
            borderRadius="5px"
            padding="5px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <DescriptionRoundedIcon fontSize="small" />
          </Box>
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap", // Prevent text from wrapping

              maxWidth: {
                xs: "100%",
                sm: "90%",
                md: "90%",
                lg: "80%",
                xl: "80%",
              },
            }}
          >
            {document.documentName}
          </Typography>
        </Stack>
        <Stack
          flexDirection={"row"}
          gap={2}
          justifyContent={"flex-end"}
          minWidth={"20%"}
        >
          <Typography variant="caption" color="text.secondary">
            {document.documentSize}
          </Typography>
          {!readOnly ? (
            <TrashIcon onClick={() => handleTrashClick(document, assetId)} />
          ) : null}
        </Stack>
      </Paper>
    </Grid>
  );
};

export default DocumentItem;
